import React from 'react';
import { clsx } from 'clsx';
import styles from './CreditLineInfo.module.scss';
import { externalUrls } from '@/constants/urls';
import { Link } from 'react-router-dom';

export interface CreditLineInfoProps {
  className?: string;
  minPaymentPercentage: number;
}

export const CreditLineInfo: React.FC<CreditLineInfoProps> = ({
  className,
  minPaymentPercentage,
}) => {
  return (
    <div className={clsx(styles.infoSection, className)}>
      <div className={styles.infoText}>
        <p>
          Ai mereu la dispoziție o limită de cash și cumpărături. Poți retrage
          toată suma sau o parte din ea. Plătești doar dacă retragi.
        </p>
      </div>

      <div className={styles.infoText}>
        <p>
          La scadență, vei plăti costul pentru zilele în care ai folosit banii
          retrași. Dacă nu rambursezi toată suma, poți plăti doar minimul:
          costul utilizării + {minPaymentPercentage * 100}% din suma retrasă.
          Cei {minPaymentPercentage * 100}% se întorc imediat în soldul tău și
          îi poți folosi din nou.{' '}
          <Link
            to={externalUrls.oceanCredit.creditLineDetails}
            className={styles.link}
            target="_blank"
          >
            Află mai multe
          </Link>
        </p>
      </div>
    </div>
  );
};
